import { UserState } from './types'

const state = (): UserState => ({
  current: null,
  showNotificationMobile: false,
  disableSoundNotifications: false,
})

export default state
